import { useState, useEffect } from 'react'
import { getCachedAuthSession } from 'services/authSessionCache'
import { get } from 'aws-amplify/api'

import HehmDevice, { HehmDeviceEquipment, HehmDeviceHardware } from 'types/HehmDevice'

const useHehmApi = (path: string) => {
  const [hehmData, setHehmData] = useState<HehmDevice | HehmDeviceEquipment | HehmDeviceHardware | null>(null)
  const [isHehmDataLoaded, setIsHehmDataLoaded] = useState(false)

  useEffect(() => {
    (async () => {
      setHehmData(null)
      setIsHehmDataLoaded(false)
      const session = await getCachedAuthSession()

      try {
        const authToken = session?.tokens?.idToken?.toString() || ''

        const res = await get({
          apiName: 'hehmApi',
          path,
          options: {
            headers: {
              'Authorization': `Bearer ${authToken}`
            }
          }
        }).response

        if (res.statusCode >= 400) {
          throw new Error('Failed to fetch HEHM data, path: ' + path)
        }

        const data = (await res.body.json()) as unknown as HehmDevice | HehmDeviceEquipment | HehmDeviceHardware

        setHehmData(data || null)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (_error) {
        setHehmData(null)
      } finally {
        setIsHehmDataLoaded(true)
      }
    })()
  }, [path])

  return {
    hehmData,
    isHehmDataLoaded
  }
}

export default useHehmApi
